import { render, staticRenderFns } from "./TabelaClassificacao.vue?vue&type=template&id=e2fccdbc&scoped=true"
import script from "./TabelaClassificacao.vue?vue&type=script&lang=js"
export * from "./TabelaClassificacao.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=e2fccdbc&prod&scoped=true&lang=scss&external"
import style1 from "./TabelaClassificacao.vue?vue&type=style&index=1&id=e2fccdbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fccdbc",
  null
  
)

export default component.exports